import { render, staticRenderFns } from "./AddDictData.vue?vue&type=template&id=2fa2b5c6&scoped=true"
import script from "./AddDictData.vue?vue&type=script&lang=js"
export * from "./AddDictData.vue?vue&type=script&lang=js"
import style0 from "./AddDictData.vue?vue&type=style&index=0&id=2fa2b5c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa2b5c6",
  null
  
)

export default component.exports